<template>
	<div style="margin-top:10px;background:var(--grey-6);padding:10px;">
		<Button label="Debug" @click="toggleDebug" :class="this.$store.state.debug ? 'debug' : 'grey'" style="margin-left:0px" />
		<!--Button label="Log" :badge="unReadErrorMessages.length"
			:class="unReadErrorMessages && unReadErrorMessages.length > 0 ? 'error' : 'grey'"
			@click.stop="showSubMenu('error')" /-->
	</div>
</template>
<script>
import { STORE_COMMIT } from '../../store/store';


//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "ResellerDebug",
	components: {},
	mixins: [],
	props: {

	},
	data() {
		return {

		};
	},
	computed: {

		get() {
			//return this.$store.state.productStore.data.productList.filter(product => product !== null);
			//return this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]
			return 1

		}

		//baseModel() {
		//	return this.$store.getters[STORE_GETTER.BASE_MODEL]
		//},


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });
		toggleDebug(){
			this.$store.commit(STORE_COMMIT.TOGGLE_DEBUG);
		}

	},
	created() {

	}
};
</script>

<style scoped></style>